import React from 'react'
import {IconQuestionMark} from "@tabler/icons-react"
import {ActionIcon, Tooltip} from "@mantine/core";
import {useTranslation} from "react-i18next";

export default function HelpButton({isMobile}) {
    const url = "https://helpbeaconama.net/appendices/orion-status-checker/"
    const navHelpLink = () => {
        window.open(url, "_blank");
    }
    const {t} = useTranslation()
    return (
        <>
            {isMobile ? (
                <ActionIcon onClick={navHelpLink} radius="100%" variant="white" ><IconQuestionMark/></ActionIcon>
            ) : (
                <Tooltip withArrow={true} label={t("Help")} transitionProps={{ transition: 'slide-down', duration: 300 }}  position="bottom">
                    <ActionIcon onClick={navHelpLink} radius="100%" variant="white" mt="7px"><IconQuestionMark/></ActionIcon>
                </Tooltip>
                )}
        </>

    )
}